import _ from 'lodash';

export const genresToGTMFormat = (genres) => _.map(genres, (genre) => ({ genre }));
